"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),require("./pc"),require("./android"),require("./ios");


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@3.0.14@dingtalk-jsapi/platform/index.js
// module id = 1154
// module chunks = 106